import { SORTING_ORDER } from 'common/constants/sm-constants';
import { DataModel, QueryParams, WidgetModel } from './base-model';

export class GridModel<T> extends DataModel {
    pageModel: T[] = [];
    originalModel: T[] = [];
    filterModel: T[] = [];
    pages: number[] = [];
    selectedPage: number = 1;
    search_text: string = '';
    recordPerPage: number = 10;
    totalRecords: number = 0;
    selectValues: any[] = [];
    pageNumber: 0;
    pageSize: 10;
    direction:'';
    column:'';
    extraData:any;
    chartsData: any = {};
}

export class GridWidgetModel extends WidgetModel {
    search_text: string = '';
    selectedPage!: number;
    recordPerPage!: number;
    sortingFeild!: Headers;
    searchableFeilds: string[] = [];
    override transferData: any;
}

export class GridParams extends QueryParams {
    recordPerPage: number = 10;
    currentPage: number = 1;
    sortingFeild!: Headers;
    sortingOrder!: SORTING_ORDER;
    search_text: string = '';
    filterFeilds: string[] = [];
    searchableFeilds: string[] = [];
    pathParam: any;
    pageNumber: 0;
    pageSize: 10;
    direction:'';
    column:'';
    transferData: any = null;
}

export class GridPostParams {}

export class gridPostParams {
    id: any;
    sortBy: string;
}

export class GridData<T extends DataModel> {
    pageModel!: T[];
    pages!: number[];
}
